import { z } from 'zod';
import { TimestampSchema } from '../common.js';
import { Iso639_1Schema } from './agent.js';
/**
 * Per-agent, per-language instruction body — see docs/data-model.md §4.7.
 * PK = TENANT#<tenantId>, SK = AGENT#<agentId>#INSTRUCTION#<lang>
 */
export const AgentInstructionSchema = z.object({
    agentId: z.string().uuid(),
    lang: Iso639_1Schema,
    body: z.string().max(16384),
    updatedAt: TimestampSchema,
});
//# sourceMappingURL=agentInstruction.js.map